/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react'
import { Loader } from '@refera/ui-web'
import { Grid, Box, Chip, Typography } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { getCategoryList } from '_/modules/service-orders/actions'
import MultiSelectedTree from '_/components/multi-selected-tree-view'

import useStyles from './styles'
import { DraggableModal } from '_/components/common/draggable-modal'

const emptyFunction = () => {}

const CategoryModal = ({
  value,
  handleModal,
  handleContinue = emptyFunction,
  patchCategories,
  submitButtonText = 'Salvar',
  isServiceOrder = false,
  showChip = true,
  ...props
}) => {
  const styles = useStyles()
  const dispatch = useDispatch()
  const [categoryList, setCategoryList] = useState([])
  const [selectCategories, setSelectCategories] = useState([])
  const [loading, setLoading] = useState(false)

  const [hasError, setError] = useState(false)
  const [treeOpen, setTreeOpen] = useState(false)

  useEffect(() => {
    const serviceCategory = categoryList?.filter(category => value.includes(category?.id))
    if (serviceCategory.length === 0 && categoryList.length > 0) {
      setTreeOpen(true)
    }
    setSelectCategories(serviceCategory)
  }, [categoryList])

  const toggleTree = () => {
    setTreeOpen(prev => !prev)
  }

  const handleSelect = selectedItems => {
    setError(false)
    setSelectCategories(selectedItems)
  }

  const handleSubmit = async () => {
    const selectedIds = selectCategories.map(cat => cat.id)
    const error = value.sort().toString() === selectedIds.sort().toString()

    if (error && !handleContinue) {
      setError(true)
      return
    }

    patchCategories(selectedIds)

    if (handleContinue !== emptyFunction) {
      handleContinue()
    } else {
      handleModal()
    }
  }

  async function fetchCategories() {
    setLoading(true)

    const res = await dispatch(getCategoryList({ isActive: true, allowsSelection: true }))

    const orderServiceCategories = isServiceOrder
      ? props?.categoriesSO?.toJS()
      : props?.tradesmanCategories

    const newCategories =
      orderServiceCategories?.filter(cat => !res.some(allCat => allCat.id === cat.id)) || []

    setCategoryList(res.concat(newCategories))
    setLoading(false)
  }

  useEffect(() => {
    fetchCategories()
  }, [])

  useEffect(() => {
    if (!showChip) {
      toggleTree()
    }
  }, [showChip])

  return (
    <DraggableModal
      open
      onClose={handleModal}
      isSubmitDisabled={!selectCategories?.length || loading}
      onSubmit={handleSubmit}
      title={props?.title || 'Categorias do chamado'}
      submitButtonText={submitButtonText}
    >
      {loading ? (
        <Grid className={styles.loader}>
          <Loader open={loading} />
        </Grid>
      ) : (
        <Grid className={styles.modal}>
          <Grid>
            <Typography className={styles.label}>Categorias</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, padding: 5 }}>
              {!treeOpen &&
                showChip &&
                selectCategories.map(category => (
                  <Chip
                    key={category?.id}
                    label={category?.name}
                    className={styles.chip}
                    onClick={toggleTree}
                  />
                ))}
            </Box>
            {treeOpen && (
              <MultiSelectedTree
                data={categoryList}
                categories={selectCategories}
                onSelectedItemsChange={handleSelect}
                onlyParent={isServiceOrder}
              />
            )}
            {hasError && <Typography className={styles.error}>Conteúdo já existente</Typography>}
          </Grid>
        </Grid>
      )}
    </DraggableModal>
  )
}

export default React.memo(CategoryModal)
